var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { StepType } from "@types";
import { findSourceById, getSelectedStepDetailsById, handleStepFieldValueChanges, registerStep, validateSource, validateStep, validateStepNameAndId } from "@utils";
import { FormSection } from "@components/FormSection/FormSection";
import { SourceSelectorInput } from "../SourceSelector/SourceSelectorInput";
import { AsyncButton, hasValue, TextArea } from "uxp/components";
import { getCustomTransformation } from "@query-engine-service";
import Icon from '@images/transform.svg';
import Copilot from '@images/copilot.svg';
import './CustomTransform.scss';
export function renderStep(context, query, onChange, selectedStepId) {
    const { step, index, previousSteps, selectedSources } = getSelectedStepDetailsById(query, selectedStepId);
    const _step = Object.assign({}, step);
    const $L = (key) => context.uxpContext.$L(key);
    const [errors, setErrors] = useState({});
    const [desc, setDesc] = useState('');
    useEffect(() => {
        const { isValid, errors } = validateStep(query, step);
        const resolved = Object.fromEntries(Object.entries(errors || {}).map(([k, v]) => [k, v && v.startsWith('lqe.') ? $L(v) : v]));
        setErrors(resolved);
        setDesc((step === null || step === void 0 ? void 0 : step.description) || '');
    }, [step]);
    function onValueChange(field, value, source) {
        return __awaiter(this, void 0, void 0, function* () {
            const _query = yield handleStepFieldValueChanges(context, query, selectedStepId, field, value, source);
            onChange(_query);
        });
    }
    const source = findSourceById(query, _step === null || _step === void 0 ? void 0 : _step.source);
    return React.createElement(React.Fragment, null,
        React.createElement(FormSection, { label: $L('lqe.step.transform.source'), error: errors === null || errors === void 0 ? void 0 : errors.source },
            React.createElement(SourceSelectorInput, { source: source, onChange: newSource => {
                    onValueChange('source', newSource, true);
                }, availableSources: [...previousSteps, ...selectedSources], query: query })),
        React.createElement(FormSection, { label: $L('lqe.step.transform.desc-label'), error: errors === null || errors === void 0 ? void 0 : errors.description },
            React.createElement("div", { className: "lqe-ct__content-1adc1d14" },
                React.createElement("div", { className: "lqe-ct__input-row-1adc1d14", title: _step.code },
                    React.createElement(TextArea, { value: desc || '', onChange: s => {
                            setDesc(s);
                        } }),
                    (!_step.code || desc != _step.description) && React.createElement(AsyncButton, { icon: Copilot, className: "lqe-ct__apply-btn-1adc1d14", disabled: !hasValue(desc), onClick: () => __awaiter(this, void 0, void 0, function* () {
                            var _a, _b;
                            let r = yield getCustomTransformation(context, desc);
                            (_b = (_a = context.uxpContext).trackAnalytics) === null || _b === void 0 ? void 0 : _b.call(_a, 'custom-transform', {
                                message: desc,
                                success: true
                            });
                            onValueChange('description', desc);
                            onValueChange('code', r.code);
                            onValueChange('added', r.added || []);
                            onValueChange('removed', r.removed || []);
                        }), title: "Apply" })),
                React.createElement("div", { className: "lqe-ct__info-1adc1d14" },
                    $L('lqe.step.transform.examples'),
                    React.createElement("ul", null,
                        React.createElement("li", null, "Convert the 'Value' field to a number"),
                        React.createElement("li", null, "Take the domain portion of the 'Email' field and add it as a new field called 'Domain'"),
                        React.createElement("li", null, "Remove all '$' symbols from the Currency field and convert it to a number")),
                    $L('lqe.step.transform.free-examples'),
                    React.createElement("ul", null,
                        React.createElement("li", null, "add a new 'TimeSinceLastUpdate' field that has a friendly label showing how much time has passed since the timestamp. Example: '45min ago' or '2 days ago'"))))));
}
function validate(query, step) {
    const errors = validateStepNameAndId(step);
    // validate source
    const source = validateSource(query, step, 'source');
    if (!source.isValid)
        errors.source = source.error;
    if (!hasValue(step.description))
        errors.description = 'lqe.step.transform.error-no-desc';
    if (!hasValue(step.code))
        errors.code = 'lqe.step.transform.error-unsaved';
    return {
        isValid: Object.keys(errors).length === 0,
        errors
    };
}
registerStep({
    type: StepType.CustomTransform,
    name: "lqe.step.transform.name",
    description: "lqe.step.transform.description",
    icon: Icon,
    render: renderStep,
    validate: validate,
    onSelectStep: (basicProps, previousSource) => {
        return Object.assign(Object.assign({}, basicProps), { source: previousSource, description: '', code: '' });
    }
});
